$('.brand-carousel').owlCarousel({
    loop: true,
    autoplay: true,
    nav: false,
    selectedAttraction: 0.001,
    draggable: true,
    freeScroll: false,
    autoplayHoverPause: true, // Pauses autoplay on hover
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      1000: {
        items: 1
      }
    }
});

function formatQuickViewMoney(cents, format) {
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents, format || Shopify.money_format);
  }

  var moneyFormat = format || '${{amount}}';
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) return '0';

    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsPart = parts[1] ? decimal + parts[1] : '';

    return dollars + centsPart;
  }

  switch ((moneyFormat.match(placeholderRegex) || [])[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return moneyFormat.replace(placeholderRegex, value);
}

function updateQuickViewVariant(quickView) {
  var variantsScript = quickView.querySelector('[data-quick-view-variants]');
  if (!variantsScript) return;

  var variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch (error) {
    return;
  }

  var selectedOptions = Array.from(quickView.querySelectorAll('.quick-view-option')).map(function(select) {
    return select.value;
  });

  var selectedVariant = variants.find(function(variant) {
    return selectedOptions.every(function(option, index) {
      return variant.options[index] === option;
    });
  });

  var variantInput = quickView.querySelector('[data-quick-view-variant-id]');
  var addButton = quickView.querySelector('.addToCart');
  var unavailableMessage = quickView.querySelector('[data-quick-view-unavailable]');
  var price = quickView.querySelector('[data-quick-view-price]');
  var sku = quickView.querySelector('[data-quick-view-sku]');

  if (!selectedVariant) {
    if (addButton) addButton.setAttribute('disabled', 'disabled');
    if (unavailableMessage) unavailableMessage.hidden = false;
    return;
  }

  if (variantInput) variantInput.value = selectedVariant.id;
  if (sku) sku.textContent = selectedVariant.sku || '';
  if (price) price.innerHTML = formatQuickViewMoney(selectedVariant.price, quickView.dataset.moneyFormat);

  if (addButton) {
    if (selectedVariant.available) {
      addButton.removeAttribute('disabled');
    } else {
      addButton.setAttribute('disabled', 'disabled');
    }
  }
  if (unavailableMessage) unavailableMessage.hidden = selectedVariant.available;
}

document.addEventListener('change', function(event) {
  var quickView = event.target.closest('[data-quick-view-product]');
  if (!quickView) return;

  var quantitySelect = event.target.closest('.quantityInput');
  if (quantitySelect) {
    var quantityInput = quickView.querySelector('.quantity-input');
    if (quantityInput) quantityInput.value = quantitySelect.value;
  }

  if (!event.target.closest('.quick-view-option')) return;
  updateQuickViewVariant(quickView);
});
